<template>
  <el-card class="box-card">
    <el-form-item
      v-if="formData.bossnow_user && formData.bossnow_user.length > 0"
    >
      <el-button
        type="primary"
        @click="dialogVis = true"
      >
        <i class="el-icon-plus"></i>
        {{ $t('api.user.actions.create') }}
      </el-button>
    </el-form-item>
    <el-form-item
      :label="$t('api.user_bossnow.name')"
      prop="bossnow_user"
      :rules="$attrs.rules"
      >
      <el-card
        class="box-card"
        v-for="(uData, idx) in formData.bossnow_user"
        :key="uData.uid"
        >
        <div slot="header" class="clearfix">
          <el-tooltip class="item"
            effect="dark"
            placement="top-start"
            >
            <div
              slot="content"
              class="tool-tip-content"
              >
              <div
                class="allow-click-copy"
                @click="doCopy(uData.uid)"
                >
                UID: {{ uData.uid }}
              </div>
            </div>
            <span>
              <i class="el-icon-message"></i>
              <span
                class="allow-click-copy"
                @click="doCopy(uData.email)"
                >
                {{ uData.email }}
              </span>
            </span>
          </el-tooltip>
          <div
            v-if="uData.type === 'default'"
            class="right desc"
            >
            {{ $t('api.user.defaultUser') }}
          </div>
        </div>
        <el-row :gutter="20">
          <el-col :xs="24">
            <el-tag
              type="info"
              class="allow-click-copy"
              @click="doCopy(uData.auth_id)"
              >
              {{ $t('api.user.fields.auth_id.label') }}:
              {{ uData.auth_id }}
            </el-tag>
          </el-col>
        </el-row>
        <el-row :gutter="20"
          v-if="uData.display_name"
          >
          <el-col :xs="24">
            <el-tag
              type="info"
              class="allow-click-copy"
              @click="doCopy(uData.display_name)"
              >
              {{ $t('api.user.fields.display_name.label') }}:
              {{ uData.display_name }}
            </el-tag>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          v-if="typeof uData.role !== 'undefined'"
          >
          <el-col :xs="24">
            <std-opt
              v-model="uData.role"
              name="role"
              data="role"
              disabled
              >
            </std-opt>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="end">
          <el-col :xs="24" :md="6">
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="$router.push({
                path: '/user/manager/edit/' + uData.uid
              })">
              {{ $t('api.user.actions.update') }}
            </el-button>
          </el-col>
          <el-col :xs="24" :md="6">
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="delUserMapping(uData,idx)"
              >
              {{ $t('api.user.actions.delete') }}
            </el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click="dialogVis = true"
      >
        <i class="el-icon-plus"></i>
        {{ $t('api.user.actions.create') }}
      </el-button>
    </el-form-item>
    <el-dialog
      :title="$t('api.user.actions.create')"
      :visible.sync="dialogVis"
      @open="showDialog"
      custom-class="rwd-dialog">
      <el-form
        :model="userForm"
        ref="userForm"
        >
        <el-form-item
          v-show="false"
          prop="authId"
          >
          <el-input
            v-model="userForm.auth_id"
            >
          </el-input>
        </el-form-item>
        <el-form-item
          v-show="false"
          prop="email"
          >
          <el-input
            v-model="userForm.email"
            >
          </el-input>
        </el-form-item>
        <el-form-item
          v-show="false"
          prop="displayName"
          >
          <el-input
            v-model="userForm.display_name"
            >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="filter"
          :rules="emailRules"
          >
          <el-autocomplete
            v-model="userForm.filter"
            class="form-item"
            :trigger-on-focus="false"
            :fetch-suggestions="querySearch"
            @select="handleSelect"
            @clear="handleClear"
            @blur="handleBlur"
            value-key="email"
            :placeholder="$t('api.user.placeholder.auth_id_or_email')"
            clearable
            >
            <template slot-scope="{ item }">
              <b>
                <i class="el-icon-message"></i>
                {{ item.email }}
              </b>
              -
              <b>
                {{ $t('api.user.fields.auth_id.label') }}:
                {{ item.auth[0].auth_id }}
              </b>
              <div class="sub-text">
                UID: {{ item.uid }}
                <span>,
                {{ $t('api.optFields.role.label') }}: {{ getRoleName(item.role) }}
                </span>
              </div>
            </template>
            <template slot="append" v-if="isSelectedUser">
              <i class="el-icon-message"></i> {{ userForm.email || userForm.auth_id }}
              -
              UID: {{ userForm.uid }}
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-form>
      <el-form
        v-if="isNewUser"
        l-position="top"
        :model="userData"
        ref="dialogForm">
        <h4>{{ transText('user_bossnow.create') }}</h4>
        <el-card class="box-card">
          <std-opt
            v-model="userData.role"
            name="role"
            data="role"
            >
          </std-opt>
          <text-field
            v-model="userData.email"
            base="user"
            :maxlength="128"
            name="email"
            dataType="email"
            :hasDesc="true"
            >
          </text-field>
          <text-field
            v-model="userData.display_name"
            base="user"
            :maxlength="128"
            name="display_name"
            :hasDesc="true"
            >
          </text-field>
          <auth-input
            base="auth[0]"
            :formData="userData.auth[0]"
            >
          </auth-input>
        </el-card>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="dialogVis = false"
          >
          {{ $t('api.cancelBtn') }}
        </el-button>
        <el-button
          type="primary"
          @click="save"
          :loading="saveLoading"
          >
          {{ $t('api.saveBtn') }}
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { getMap, transText } from '@/utils/i18n'
import { create, fetchList } from '@/api/user/user'
import { addBossNowUserToBranch, delBossNowUserToBranch } from '@/api/user/bossnow_to_branch'
import { addBossNowUserToRegion, delBossNowUserToRegion } from '@/api/user/bossnow_to_region'

const defData = {
  uid: undefined,
  created_at: undefined,
  updated_at: undefined,
  role: 0,
  display_name: '',
  email: '',
  status: 0,
  perm_type: 0,
  auth: [{
    id: undefined,
    auth_type: 0,
    auth_id: '',
    auth_token: '',
    auth_token_c: '',
    created_at: undefined,
    updated_at: undefined
  }]
}

export default {
  name: 'bossnow-user',
  props: {
    type: {
      type: String,
      default: 'branch'
    },
    idField: {
      type: String,
      default: 'bid'
    },
    mapField: {
      type: String,
      default: 'bid'
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      base: 'user',
      dialogVis: false,
      saveLoading: false,
      isNewUser: false,
      isSelectedUser: false,
      userForm: {
        uid: 0,
        filter: '',
        role: 0,
        email: '',
        auth_id: '',
        display_name: ''
      },
      emailRules: [{
        required: false,
        type: 'email',
        message: this.$t('api.user.error.auth_id_email'),
        trigger: 'blur'
      }],
      userData: Object.assign({}, defData)
    }
  },
  methods: {
    getMap,
    doCopy,
    transText,
    getRoleName (role) {
      let ret = role
      let m = this.getMap('role')
      for (let i = 0; i < m.length; ++i) {
        let e = m[i]
        if (e.value === role) {
          ret = e.label
          break
        }
      }
      return ret
    },
    addMapping (data) {
      switch (this.type) {
        case 'branch':
          return addBossNowUserToBranch(data)
        case 'region':
          return addBossNowUserToRegion(data)
      }
    },
    delMapping (uid, mapId) {
      switch (this.type) {
        case 'branch':
          return delBossNowUserToBranch(uid, mapId)
        case 'region':
          return delBossNowUserToRegion(uid, mapId)
      }
    },
    showDialog () {
      this.$nextTick(() => {
        this.$refs.userForm.clearValidate()
      })
      this.isNewUser = false
      this.isSelectedUser = false
      this.userForm.filter = ''
      this.userForm.role = (this.formData.type === 1) ? 1 : 0
      this.userForm.uid = 0
      this.userData = JSON.parse(JSON.stringify(defData))
      this.userData.display_name = this.formData.name
    },
    querySearch (qs, cb) {
      let arr = []
      let idFilter = ''
      if (Array.isArray(this.formData.bossnow_user) && this.formData.bossnow_user.length > 0) {
        for (let i = 0; i < this.formData.bossnow_user.length; ++i) {
          arr.push(
            '{uid:{$ne:' + this.formData.bossnow_user[i].uid + '}}'
          )
        }
        idFilter = ',' + arr.join()
      }
      let q = {
        sort: '-uid',
        page: 1,
        limit: 5,
        filter: '{$and:[{status:0},{$or:[{auth_id:"%' + qs + '%"},{email:"%' + qs + '%"}]}' +
          idFilter + ']}'
      }
      fetchList(q, 'bossnow').then(res => {
        this.isNewUser = (res.data.length <= 0)
        this.isSelectedUser = false
        cb(res.data)
      }).catch(error => {
        console.log(error)
      })
    },
    handleBlur () {
      this.isNewUser = !this.isSelectedUser
    },
    handleClear () {
      this.isNewUser = false
      this.isSelectedUser = false
    },
    handleSelect (item) {
      this.isNewUser = false
      this.isSelectedUser = true
      this.userForm.uid = item.uid
      this.userForm.email = item.email
      this.userForm.auth_id = item.auth[0].auth_id
      this.userForm.display_name = item.display_name
      this.$refs.userForm.validate()
    },
    save () {
      if (this.isNewUser) {
        this.addNewUser()
      } else {
        this.addUserMapping()
      }
    },
    delUserMapping (d, idx) {
      if (!d.uid) {
        return false
      }
      if (!this.isEdit) {
        this.formData.bossnow_user.splice(idx, 1)
        return false
      }
      this.$confirm(this.$t('api.delConfirmMsg', {
        id: d.uid,
        name: d.email,
        idText: this.transText('user.id'),
        dataText: this.transText('user.mapping')
      }), this.$t('api.delConfirmTitle'), {
        confirmButtonText: this.$t('api.confirmBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.delMapping(d.uid, d.id || this.formData[this.idField]).then(response => {
          this.$message({
            message: this.transText('user_bossnow_mapping.delSuccess'),
            type: 'success',
            duration: 2000
          })
          this.formData.bossnow_user.splice(idx, 1)
        }).catch(err => {
          console.log(err)
        })
      })
    },
    addUserMapping () {
      this.$refs.userForm.validate(valid => {
        if (!valid) {
          return false
        }
        if (this.userForm.uid === 0) {
          this.dialogVis = false
          return false
        }
        if (!this.isEdit) {
          let exists = false
          for (let i = 0; i < this.formData.bossnow_user.length; ++i) {
            if (this.formData.bossnow_user[i].uid === this.userForm.uid) {
              exists = true
              break
            }
          }
          if (!exists) {
            this.formData.bossnow_user.push({
              uid: this.userForm.uid,
              auth_id: this.userForm.auth_id,
              role: this.userForm.role,
              email: this.userForm.email,
              display_name: this.userForm.display_name
            })
          }
          this.dialogVis = false
          return false
        }
        let obj = { uid: this.userForm.uid }
        obj[this.mapField] = this.formData[this.idField]
        this.saveLoading = true
        this.addMapping(obj).then(res => {
          this.$message({
            message: this.transText('user.addSuccess'),
            type: 'success',
            duration: 2000
          })
          this.formData.bossnow_user.push({
            id: res.data.id,
            uid: this.userForm.uid,
            auth_id: this.userForm.auth_id,
            role: this.userForm.role,
            email: this.userForm.email,
            display_name: this.userForm.display_name
          })
          this.dialogVis = false
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.saveLoading = false
        })
      })
    },
    addNewUser () {
      this.$refs.dialogForm.validate(valid => {
        if (!valid) {
          return false
        }
        this.saveLoading = true
        if (this.isEdit) {
          let obj = {}
          obj[this.idField] = this.formData[this.idField]
          this.userData[this.type] = [obj]
        }
        create(this.userData, 'bossnow').then(res => {
          this.$message({
            message: this.transText('user.addSuccess'),
            type: 'success',
            duration: 2000
          })
          var d = res.data
          this.formData.bossnow_user.push({
            id: d.id,
            uid: d.uid,
            auth_id: d.auth[0].auth_id,
            role: d.role,
            email: d.email,
            display_name: d.display_name
          })
          this.dialogVis = false
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.saveLoading = false
        })
      })
    }
  },
  watch: {
    isNewUser (v) {
      if (v) {
        this.$nextTick(() => {
          this.$refs.dialogForm.clearValidate()
        })
      }
    },
    'userForm.filter' (v) {
      if (this.userData && this.userData.auth[0]) {
        this.userData.auth[0].auth_id = v
        this.userData.email = v
        this.userData.role = (this.formData.type === 1) ? 1 : 0
      }
    }
  }
}
</script>
